import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { ChangeLog } from '../types';

export const changeLogsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getChangeLogs: build.query<Response<ChangeLog>, string>({
      query: (query) => ({
        url: `/v1/audit-log${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getChangeLogById: build.query<Response<{ data: ChangeLog }>, string>({
      query: (id) => ({
        url: `/v1/audit-log/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const { useLazyGetChangeLogsQuery, useLazyGetChangeLogByIdQuery } =
  changeLogsApi;

export const {
  endpoints: { getChangeLogs, getChangeLogById },
} = changeLogsApi;
